<template>
  <main class="no-japanese flex-all-center">
    <p class="note">日本語ページではご利用いただけません。</p>
  </main>
</template>

<script>
export default {
  name: "NotJapanese",
};
</script>

<style scoped>
.no-japanese {
  min-height: calc(100vh - 175px);
  .note {
    line-height: 1.5;
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sp/NotJapanese.vue